import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'releaseTimeParser',
  standalone: true,
})
export class RequestReleaseTimeParserPipe implements PipeTransform {
  transform(value: string | undefined): unknown {
    if (!value) return '-';

    // 09
    if (value.length === 2) {
      return value + ':00';
    }

    // 09:00:00
    if (value.length === 8) {
      return value.slice(0, 5);
    }

    return value;
  }
}
